// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__uzBbv"};